"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _SelectComponent = _interopRequireDefault(require("../../SelectComponent"));

var _ProfileProvider = require("../../../provider/ProfileProvider");

var _FooterNavigation = _interopRequireDefault(require("../../FooterNavigation"));

var _useOurTranslation = _interopRequireDefault(require("../../../utils/useOurTranslation"));

var _ViewContainer = _interopRequireDefault(require("../../ViewContainer"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Transition = /*#__PURE__*/_react.default.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Slide.default, (0, _extends2.default)({
    direction: "up",
    ref: ref
  }, props));
});

var SingleComponent = function SingleComponent(_ref) {
  var open = _ref.open,
      handleRevert = _ref.handleRevert,
      handlePropertySave = _ref.handlePropertySave,
      config = _ref.config;
  var t = (0, _useOurTranslation.default)('profile-components:Edit');
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  var state = context[config.valueName];
  var valueUntouched = !(Array.isArray(state.touched) ? state.touched.includes(config.identifier || config.valueName) : state.touched);
  var missingValues = config.isSet ? !config.isSet(state) : false;
  var invalidValue = typeof config.allowEmpty !== 'undefined' ? false : valueUntouched || missingValues;

  var handleClickSave = function handleClickSave() {
    handlePropertySave(config.valueName);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.default, {
    fullScreen: true,
    fullWidth: true,
    open: open,
    onClose: handleRevert,
    TransitionComponent: Transition,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _styleModule.default.box,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ViewContainer.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectComponent.default, {
          componentConfiguration: (0, _extends2.default)({}, config, {
            isSingleView: true
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FooterNavigation.default, {
        highlightRightButton: !invalidValue,
        rightButtonDisabled: invalidValue,
        onLeftButtonClick: handleRevert,
        onRightButtonClick: handleClickSave,
        buttonRightText: t('save'),
        buttonLeftText: t('cancel'),
        hideButtonChevrons: true
      })]
    })
  });
};

var _default = SingleComponent;
exports.default = _default;